const styleSwedishLocale = (str) => str
    .replace(/[–](?=\d)|\d(?=[–])/gi, '$& ')
    .replaceAll('.', '')
    .replaceAll(':', '.');

export { styleSwedishLocale };
